export function isMobileDevice() {
  if (typeof navigator === "undefined") return false;
  return /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
}

/** Böngészős getUserMedia (HTTPS / localhost). */
export function canUseInPageCamera() {
  return (
    typeof window !== "undefined"
    && !!window.isSecureContext
    && !!navigator.mediaDevices?.getUserMedia
  );
}

/** Miért nem indul a kamera — magyar szöveg UI-hoz / toast-hoz. */
export function inPageCameraBlockReason() {
  if (typeof window === "undefined") return null;
  if (!navigator.mediaDevices?.getUserMedia) {
    return "A böngésző nem támogatja az oldalon belüli kamerát.";
  }
  if (window.isSecureContext) return null;
  const { protocol, hostname } = window.location;
  if (protocol === "http:" && /^\d{1,3}(\.\d{1,3}){3}$/.test(hostname)) {
    return "Telefonon a http:// Wi‑Fi cím nem biztonságos — a böngésző nem ad kamerát. Indítsd a dev szervert HTTPS-sel: DEV_HTTPS=1 ./scripts/dev-minimal.sh both (mkcert), majd nyisd meg a https://… címet.";
  }
  if (protocol === "http:") {
    return "A kamera csak HTTPS-en (vagy localhoston) érhető el.";
  }
  return "A kamera nem elérhető ebben a környezetben.";
}
